export enum TrustBox {
  Button = 'button',
  Combo = 'combo',
  List = 'list',
  LivePreview = 'livePreview',
  Micro = 'micro',
  MicroScore = 'microScore',
  MicroStar = 'microStar',
  MiniCarousel = 'miniCarousel',
  Slider = 'slider',
}
